import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {GetIpData, getIPInfo} from '../reportSlices/reportAnalytics'

const IpInfoModel = ({show, handleClose, selectedIP}: any) => {
  const dispatch = useDispatch()
  const getIPInformation = useSelector(GetIpData)

  useEffect(() => {
    if (selectedIP) dispatch(getIPInfo(selectedIP))
  }, [selectedIP])

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-550px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <>
          <div className='modal-header'>
            <h1>IP Information</h1>
          </div>
          <div className='modal-body'>
            <label className='w-100'>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                IP :{' '}
              </span>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                {getIPInformation?.ip}
              </span>
            </label>
            <label className='w-100 mt-2 '>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Country :{' '}
              </span>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                {getIPInformation?.country} ({getIPInformation?.country_code})
              </span>
            </label>
            <label className='w-100 mt-2 '>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Address :{' '}
              </span>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                {getIPInformation?.city}
                {getIPInformation?.city ? ',' : ''} {getIPInformation?.subdivision}
              </span>
            </label>
            <label className='w-100 mt-2 '>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Time Zone :{' '}
              </span>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                {getIPInformation?.time_zone}
              </span>
            </label>
          </div>
          <div className='modal-footer w-100'>
            <button onClick={handleClose} type='button' className='btn btn-light-primary'>
              Cancel
            </button>
            {/* <button
              disabled={error !== '' || fieldName == ''}
              onClick={handleCreate}
              id='submit'
              type='button'
              className='btn btn-primary w-50 '
            >
              Save
            </button> */}
          </div>
        </>
      </Modal>
    </>
  )
}

export default IpInfoModel
